"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/shared/components/common/carousel";
import List from "@/shared/components/common/List";
import type { Image as TImage } from "@/types/services/hotel/hotel.types";
import { CaretLeft } from "@phosphor-icons/react";
import Image from "next/image";
import { memo, useMemo } from "react";

interface HotelCardCarouselProps {
  images: TImage[];
  slug: string;
  deviceType: DeviceType;
}

export default memo(function HotelCardCarousel({
  images,
  slug,
  deviceType,
}: HotelCardCarouselProps) {
  const memoizedimages = useMemo(
    () =>
      images
        .map((img) => ({ ...img, id: img.path }))
        .filter((img) => img.type === "thumbnail" && img.path),
    [images],
  );

  return (
    <Carousel
      dir={"ltr"}
      orientation="horizontal"
      className="md:max-w-60 md:min-w-60 group"
    >
      <CarouselContent className="h-44 mx-auto rounded-md  gap-x-2">
        <List
          items={memoizedimages}
          renderItems={({ path }) => (
            <CarouselItem className="relative">
              <Image
                quality={75}
                className="rounded-md object-cover"
                loading="lazy"
                fill
                src={path}
                alt={slug}
              />
            </CarouselItem>
          )}
        />
      </CarouselContent>

      <CarouselPrevious
        className="!w-7 !h-7 !bg-foreground hover:!bg-foreground/80 max-lg:hidden !p-0 absolute left-[2%] text-background opacity-0 hover:!text-background group-hover:opacity-70 border-none rounded-full! "
        icon={<CaretLeft size={18} weight="regular" />}
      />
      <CarouselNext className="!w-7 !h-7 !bg-foreground hover:!bg-foreground/80 max-lg:hidden absolute right-[2%] text-background opacity-0 hover:!text-background group-hover:opacity-70 border-none rounded-full! " />
    </Carousel>
  );
});
